import { render, staticRenderFns } from "./NewReport.vue?vue&type=template&id=1b39e820&scoped=true&"
import script from "./NewReport.vue?vue&type=script&lang=js&"
export * from "./NewReport.vue?vue&type=script&lang=js&"
import style0 from "./NewReport.vue?vue&type=style&index=0&id=1b39e820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b39e820",
  null
  
)

export default component.exports